import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Banner from '../../components/Banner';
import Breadcrumb from '../../components/Breadcrumb';
import SEO from '../../components/SEO';
import '../../styles/pages/ClientTestimonials.css';
import TestiBg from '../../images/testi-bg.jpeg';
import Testimonials from '../../components/Testimonials'
import logo1 from "../../images/aws_logo.png";
import logo2 from "../../images/Logo-Google-Cloud.png";
import logo3 from "../../images/heroku_logo.png";
import logo4 from "../../images/openstack-logo.png";
import logo5 from "../../images/digital_ocean_logo.png";

/* ---------------- DATA ---------------- */
const clients = [
    { id: 1, img: logo1, name: "Client 1", type: "client" },
    { id: 2, img: logo2, name: "Client 2", type: "client" },
    { id: 3, img: logo3, name: "Job Seeker 1", type: "job" },
    { id: 4, img: logo4, name: "Client 3", type: "client" },
    { id: 5, img: logo5, name: "Job Seeker 2", type: "job" },
];

/* ---------------- ANIMATIONS ---------------- */
const sectionVariant = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.6 } },
};

const titleVariant = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const filterVariant = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { staggerChildren: 0.1 } },
};

const filterItem = {
    hidden: { opacity: 0, scale: 0.92 },
    show: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const logoItem = {
    hidden: { opacity: 0, y: 40, scale: 0.92 },
    show: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: {
        opacity: 0,
        y: 20,
        scale: 0.92,
        transition: { duration: 0.35, ease: "easeIn" },
    },
};

/* ---------------- COMPONENT ---------------- */
const ClientTestimonials = () => {
    const [filter, setFilter] = useState("all");

    const filteredClients = clients.filter(
        (c) => filter === "all" || c.type === filter
    );

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO
                title="Client Testimonials"
                description="See what our clients say about Fortune Cloud Solutions."
            />

            <Banner title="CLIENT TESTIMONIALS" image={TestiBg} />

            <div className="container">
                <Breadcrumb />

                <motion.section
                    className="py-5 text-center"
                    variants={sectionVariant}
                    initial="hidden"
                    animate="show"
                >
                    {/* TITLE */}
                    <motion.h2 className="mb-3 fw-bold" variants={titleVariant}>
                        TRUSTED BY OUR CLIENTS
                    </motion.h2>

                    <motion.p className="text-muted mb-5" variants={titleVariant}>
                        Businesses and professionals that rely on Fortune Cloud Solutions
                    </motion.p>

                    {/* <motion.div
                        className="logo-filters mb-5"
                        variants={filterVariant}
                        initial="hidden"
                        animate="show"
                    >
                        <div className="filter-wrapper">
                            <motion.button
                                variants={filterItem}
                                className={`filter-btn ${filter === "all" ? "active" : ""}`}
                                onClick={() => setFilter("all")}
                                whileTap={{ scale: 0.96 }}
                            >
                                ALL
                            </motion.button>

                            <motion.button
                                variants={filterItem}
                                className={`filter-btn ${filter === "client" ? "active" : ""}`}
                                onClick={() => setFilter("client")}
                                whileTap={{ scale: 0.96 }}
                            >
                                CLIENTS
                            </motion.button>

                            <motion.button
                                variants={filterItem}
                                className={`filter-btn ${filter === "job" ? "active" : ""}`}
                                onClick={() => setFilter("job")}
                                whileTap={{ scale: 0.96 }}
                            >
                                JOB SEEKERS
                            </motion.button>
                        </div>
                    </motion.div>

                    
                    <motion.div
                        layout
                        className="row justify-content-center align-items-center g-4"
                    >
                        <AnimatePresence mode="wait">
                            {filteredClients.map((client) => (
                                <motion.div
                                    key={client.id} 
                                    className="col-6 col-sm-4 col-md-3 col-lg-3"
                                    variants={logoItem}
                                    initial="hidden"
                                    animate="show"
                                    exit="exit"
                                    whileHover={{ y: -10, scale: 1.06 }}
                                    transition={{
                                        type: "spring",
                                        stiffness: 280,
                                        damping: 20,
                                    }}
                                    layout 
                                >
                                    <div className="client-logo-card p-3 shadow-sm rounded">
                                        <img
                                            src={client.img}
                                            alt={`${client.name} logo`}
                                            className="img-fluid client-logo"
                                        />
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </motion.div> */}

                    <Testimonials />
                </motion.section>
            </div>
        </motion.div>
    );
};

export default ClientTestimonials;